import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isArray',
  standalone: false,
})
export class IsArrayPipe implements PipeTransform {
  public transform(value: any): boolean {
    return Array.isArray(value);
  }
}
